export const ROLE_TO_STRING = {
  givewith: 'Super Admin',
  org_admin: 'Org Admin',
  user_admin: 'User Admin',
  finance: 'Finance',
  sales: 'Sales',
  approver: 'Approver',
  transactor: 'Transactor',
  executive: 'Executive',
  gw_operations: 'SaaS Operations',
  gw_csm: 'SaaS CSM',
  gw_finance: 'SaaS Finance',
  sw_si_admin: 'Impact Network Admin'
};
